const ADMIN_ROLES = ['admin', 'super_admin', 'super admin', 'system_administrator', 'system administrator', 'administrator'];
const SUPER_ADMIN_ROLES = ['super_admin', 'super admin'];

export function isAdmin(role?: string): boolean {
  if (!role) return false;
  return ADMIN_ROLES.includes(role.toLowerCase().trim());
}

export function isSuperAdmin(role?: string): boolean {
  if (!role) return false;
  return SUPER_ADMIN_ROLES.includes(role.toLowerCase().trim());
}
